// Vendor libraries
import { combineReducers } from '@ngrx/store';
// Constants
export const CUSTOM_PDF_REPORT_BUILDER_APP_STATE_SLICE_KEY = 'reportBuilder';
// NgRx reducers
import { active_tab } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/active-tab/active-tab.reducer';
import { active_sub_tab } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/active-tab/active-sub-tab.reducer';
import { description } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/description/description.reducer';
import { filters } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/filters/filters.reducer';
import { include_benchmark_default } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/include-benchmark-default/include-benchmark-default.reducer';
import { live_preview } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/live-preview/live-preview.reducer';
import { modules } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/modules/modules.reducer';
import { name } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/name/name.reducer';
import { preview_securities } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/preview-securities/preview-securities.reducer';
import { report_id } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/report-id/report-id.reducer';
import { report_footer } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/report-footer/report-footer.reducer';
import { report_type } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/report-type/report-type.reducer';
import { selected_module } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/selected-module/selected-module.reducer';
import { report_orientation } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/report-orientation/report-orientation.reducer';
import { advanced_options } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/advanced-options/advanced-options.reducer';
import { data_source } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/data-source/data-source.reducer';
import { report_category } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/report-category/report-category.reducer';
import { module_config_map } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/module-config-map/module-config-map.reducer';
import { performance_disclosure_footnote } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/performance-disclosure-footnote/performance-disclosure-footnote.reducer';
export const reportBuilder = combineReducers({
    // Report state properties
    report_id,
    report_type,
    report_category,
    report_orientation,
    report_footer,
    name,
    description,
    modules,
    include_benchmark_default,
    advanced_options,
    data_source,
    performance_disclosure_footnote,
    // Frontend state properties
    selected_module,
    active_tab,
    active_sub_tab,
    filters,
    live_preview,
    preview_securities,
    module_config_map,
});
